import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  isCreateTaskModal?: boolean;
  isActive?: boolean;
}

const SignMode = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  svg {
    vertical-align: middle;
  }

  .fill-color {
    stroke: var(--background-primary);
    fill: var(--border-secondary);
  }
  align-items: center;
  p {
    ${Typography.body_md_medium}
    margin: var(--space-0);
    color: var(--text-primary);
    white-space: nowrap;
  }

  ${mobile_xl(css`
    p {
      display: inline-flex;
    }
    .fill-color {
      display: none;
    }
  `)}
`;

const RightRow1 = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  padding: var(--space-5) var(--space-11);
  border-radius: var(--border-radius-8);
  border: 0.5px solid transparent;
  &:hover {
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary);
      background: var(--background-primary);
    `}
`;

const RightText = styled.p`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
`;

const AvatarImage = styled.div`
  ${AlignCenter}
  border-radius: var(--border-radius-full);

  > div > img {
    max-width: 100%;
  }
`;
const AssignGroup = styled.div<Props>`
  padding: var(--space-4) var(--space-12);
  border-radius: var(--border-radius-8);
  &:hover {
    background: var(--background-primary);
    box-shadow: var(--border);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      background: var(--background-primary);
      box-shadow: var(--border);
    `}
  ul {
    ${AlignCenter}
    list-style-type: none;
    padding-left: var(--space-8);
    margin: var(--space-0);
  }

  li {
    margin-left: -8px;
    border-radius: var(--border-radius-full);
    z-index: var(--z-index-base);
  }
  .plus-icon {
    z-index: var(--z-index-base);
    visibility: hidden;
    width: 22px;
    height: 22px;
    background: var(--background-muted);
    border: 1px solid var(--background-secondary);
    ${FlexCenter}
  }
`;
const HumanIcon = styled.div<Props>`
  padding: var(--space-5) var(--space-7);
  border-radius: var(--border-radius-6);
  ${AlignCenter}
  gap: var(--space-6);
  box-shadow: var(--border);
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  svg path {
    fill: var(--text-secondary);
  }
  &:hover {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
    p {
      color: var(--text-primary);
    }
    svg path {
      fill: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    p {
      display: inline-flex;
    }
    padding: var(--space-5);
  `)}
  ${(props: Props) =>
    props.isCreateTaskModal &&
    css`
      padding: var(--space-3) var(--space-8);
      border-radius: var(--border-radius-6);
      ${mobile_xl(css`
        padding: var(--space-3) var(--space-8);
      `)}
    `}
    ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
      p {
        color: var(--text-primary);
      }
      svg path {
        fill: var(--text-primary);
      }
    `}
`;

const AssignBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  svg {
    margin: var(--space-0);
  }
  .selected {
    background: var(--neutral-secondary);
    .checkbox-round {
      border: 1px solid var(--text-secondary);
    }
  }
  :last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
const Assign = styled.div<Props>`
  padding: var(--space-6) var(--space-7);
  border-radius: var(--border-radius-6);
  ${AlignCenter}
  gap: var(--space-6);
  box-shadow: var(--border);
  border-radius: var(--border-radius-6);
  flex-wrap: wrap;

  &:hover {
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    padding: var(--space-5);
    flex-wrap: wrap;
    max-width: max-content;
  `)}
  ${(props: Props) =>
    props.isCreateTaskModal &&
    css`
      padding: var(--space-3) var(--space-8);
      border-radius: var(--border-radius-6);
      ${mobile_xl(css`
        padding: var(--space-3) var(--space-8);
      `)}
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      box-shadow: var(--border);
      background-color: var(--neutral-secondary);
    `}
`;

const Div = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

const BlankDiv = styled.div`
  width: 14px;
  height: 14px;
`;

export { SignMode, RightRow1, AvatarImage, AssignGroup, RightText, HumanIcon, AssignBottom, Assign, Div, BlankDiv };
